import { GET_PORTFOLIO } from '../actions/actionTypes';

const initialState = {
  portfoliocardItemData:[],portfoliototalCount:0,portfoliocardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};


export default function portfolio(state = initialState, action) {

  switch (action.type) {
     case GET_PORTFOLIO:
      
      return{
       ...state,
       portfoliocardData: action.getCardData,
       portfoliototalCount:action.totalCount,
       portfoliocardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow,
       userName:action.userName
      

      };
     
    default: return state;
  }
};

